(() => {
  'use strict';
  function init() {
    if (window.ucwYsaOverlayInitialized) return;
    window.ucwYsaOverlayInitialized = true;
    const body = document.body;
    const html = document.documentElement;
    const desktop = window.matchMedia('(min-width: 901px) and (hover: hover)');
    let frame = 0;
    function update() {
      frame = 0;
      const searchOpen = html.classList.contains('ucw-search-open');
      const cartOpen = body.classList.contains('uw-cart-popup-open');
      const mobileMenuOpen = body.classList.contains('uw-mobile-menu-open');
      const desktopMenuOpen = desktop.matches && Boolean(document.querySelector('.uw-menu-overlay.is-active, .uw-menu__item--has-dropdown:is(:hover, :focus-within)'));
      const popupOpen = Boolean(document.querySelector('dialog[open], .uw-printer-popup.is-open, .uw-login-printer-popup.is-open'));
      const hidden = searchOpen || cartOpen || mobileMenuOpen || desktopMenuOpen || popupOpen;
      if (body.classList.contains('ucw-ysa-overlay-hidden') !== hidden) {
        body.classList.toggle('ucw-ysa-overlay-hidden', hidden);
      }
      if (body.classList.contains('ucw-trust-widget-hidden') !== hidden) body.classList.toggle('ucw-trust-widget-hidden', hidden);
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    const observer = new MutationObserver(schedule);
    observer.observe(html, { attributes: true, attributeFilter: ['class'] });
    observer.observe(body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-hidden'] });
    function menuChanged(event) {
      if (event.target instanceof Element && event.target.closest('.uw-menu')) schedule();
    }
    for (const event of ['pointerover', 'pointerout', 'focusin', 'focusout']) {
      document.addEventListener(event, menuChanged);
    }
    document.addEventListener('close', schedule, true);
    document.addEventListener('cancel', schedule, true);
    desktop.addEventListener('change', schedule);
    window.addEventListener('pageshow', schedule);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

